"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var collection_claims_1 = require("../../utils/shopify-graphql/collection-claims");
var hooks_1 = require("preact/hooks");
var path_1 = require("../../utils/shopify/path");
var Parser_1 = require("../Parser");
var color_1 = require("../common/color");
var CollectionClaims = function () {
    var _a = (0, hooks_1.useState)(null), data = _a[0], setData = _a[1];
    (0, hooks_1.useEffect)(function () {
        var handle = location.pathname.split('/')[2];
        // this will return 'collection', 'product', or 'page' based on url
        var pathType = (0, path_1.getPathType)(location);
        if (!pathType) {
            console.error('this module needs to be loaded within Collection or Page or Product url');
            return;
        }
        (0, collection_claims_1.getCollectionClaimsData)(handle, pathType)
            .then(function (d) { return setData(d); })
            .catch(function (err) { return console.error(err); });
    }, []);
    if (!data) {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
    return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)("div", { class: "collection-claims__content-container" },
            (0, preact_1.h)("h1", { class: "collection-claims__header", style: { color: (0, color_1.toHex)(data.color || 'charcoal') } }, data.header),
            data.contents.map(function (text, index) { return ((0, preact_1.h)("p", { key: index, class: "collection-claims__description" }, (0, Parser_1.parse)(text))); }))));
};
exports.default = CollectionClaims;
